module.exports = __webpack_public_path__ + "static/media/carousel-aniversario.80e21f44.png";